/**
 * @file help-routing.module.ts
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpComponent } from './help.component';
import { TpaFAQComponent } from './tpa-faq/tpa-faq.component';
import { CustomerSupportComponent } from './customer-support/customer-support.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { LABELS } from '@root/assets/doc/labels';

const routes: Routes = [
  {
    path: '', component: HelpComponent, children: [
      { path: 'tpa-faq', component: TpaFAQComponent, title: LABELS.LABEL_FAQS },
      { path: 'support', component: CustomerSupportComponent, title: LABELS.LABEL_COMMON_CUSTOMER_SUPPORT },
      // { path: 'about-us', component: AboutUsComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent, title: LABELS.LABEL_MORE_PRIVACY_POLICY },
      { path: 'terms-of-use', component: TermsOfUseComponent, title: LABELS.MENU_TERMS_OF_USE }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HelpRoutingModule { }
